import React, { FC } from 'react';
import { getGoodsSupplyCase, getStocksInStores, GoodsSupplyCase } from 'features/goods-supply';
import { getDivisionName, getProductBelong, isWebSellable, ProductBelong } from 'features/product-info';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { Dispatch } from 'redux';
import { ConnectedProps } from 'types/utils';
import { TitleNonInteractive, TitleInteractive } from 'common/components/stocks-in-stores';
import { AvailableStores, StoreStockData } from 'common/components/stocks-in-stores/types';
import { Department } from 'common/components/stocks-in-stores/department';
import { getRegionCode } from 'common/selectors';
import { getAvailabledStores } from 'features/bisiness-units/selectors';
import { PDP_STOCKLIST_SHOWED } from './actions';
import { useStocksLogic } from './hooks/use-stocks-logic';
import { StyledContainer } from './styles';

export const DATA_QA_STOCK_IN_STORES_CONTAINER = 'stock-in-stores-container';

type State = {
  stocks: StoreStockData[];
  supplyCase: GoodsSupplyCase | null;
  isSellable: boolean;
  stores: AvailableStores;
  divisionName?: string | null;
  productBelong: ProductBelong;
  regionCode: string;
};
type Props = ConnectedProps<State, typeof mapDispatchToProps> & { isSet: boolean };

export const StocksInStores: React.FC<Props> = ({
  stocks,
  supplyCase,
  isSellable,
  onStocklistShow,
  stores,
  divisionName,
  productBelong,
  regionCode,
  isSet,
}) => {
  const { showInteractiveTitle, showNonInteractiveTitle, availableStore, onStocklistShowDispatch } =
    useStocksLogic(stores, stocks, supplyCase, onStocklistShow);
  const stockInStoresEmpty =
    stocks.length === 0 ||
    stocks.filter(
      ({ stockValue, displaySample }: { stockValue: number; displaySample: boolean }) =>
        stockValue > 0 || displaySample,
    ).length === 0;

  const showContent =
    (isSet || isSellable) && !stockInStoresEmpty && (showInteractiveTitle || showNonInteractiveTitle);
  const isFromMarketplace = productBelong === 'LeroyMerlinMarketplace';
  const otherContent = divisionName && !isFromMarketplace && <Department department={divisionName} />;
  const TitleWithDivisionAndPickup: FC = () => {
    if (showInteractiveTitle) {
      return (
        <TitleInteractive
          stocks={stocks}
          onStockListShowDispatch={onStocklistShowDispatch}
          otherContent={otherContent}
        />
      );
    }
    if (showNonInteractiveTitle) {
      return (
        <>
          <TitleNonInteractive availableStore={availableStore} regionCode={regionCode} stocks={stocks} />
          {otherContent}
        </>
      );
    }

    return null;
  };

  return (
    <StyledContainer data-qa={DATA_QA_STOCK_IN_STORES_CONTAINER}>
      {showContent && <TitleWithDivisionAndPickup />}
    </StyledContainer>
  );
};

const mapStoreToProps = (store: RootReducer): State => {
  const stocks = getStocksInStores(store);
  const supplyCase = getGoodsSupplyCase(store);
  const isSellable = isWebSellable(store);
  const stores = getAvailabledStores(store);
  const divisionName = getDivisionName(store);
  const productBelong = getProductBelong(store);
  const regionCode = getRegionCode(store);

  return {
    stocks,
    supplyCase,
    isSellable,
    stores,
    divisionName,
    productBelong,
    regionCode,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onStocklistShow: () => dispatch(PDP_STOCKLIST_SHOWED()),
});

export const PdpStocksInStores = connect(mapStoreToProps, mapDispatchToProps)(StocksInStores);
